import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import path from 'path'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Download APK V18.80 – New Version Update 2026`,
			keywords: 'gb whatsapp, gbwhatsapp, gb whatsapp download, gb whatsapp apk, gbwhatsapp app',
			description: `Download latest version of GB WhatsApp APK with new features. GBWhatsApp will keep updating new customized features for Android users.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-dwnplus.org/'
				}
			]
		},
		component: Home,
	},
	{
		path: '/features/',
		name: 'features',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Features Overview – Messages, Media & Privacy`,
			keywords: 'gb whatsapp features, gb whatsapp privacy, gb whatsapp media',
			description: `Explore GB WhatsApp features including enhanced messaging, media sharing, privacy controls, and customization.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/features/`,
				},
			],
		},
		component: () => import('@/views/features.vue'),
	},
	{
		path: '/features/privacy/',
		name: 'features-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Privacy Features – Hide Online Status, Freeze Last Seen & Anti-Revoke`,
			keywords: 'gb whatsapp privacy, hide online status, freeze last seen, anti-delete messages',
			description: `Learn about GB WhatsApp privacy features: hide online status, freeze last seen, anti-delete messages, and advanced privacy controls.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/features/privacy/`,
				},
			],
		},
		component: () => import('@/views/features-privacy.vue'),
	},
	{
		path: '/features/media/',
		name: 'features-media',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Media Features – High-Quality Sharing & Large File Transfer`,
			keywords: 'gb whatsapp media, high quality images, video sharing, large file transfer',
			description: `Discover GB WhatsApp media features: high-quality image sharing, large file transfer, video compression control, and media management.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/features/media/`,
				},
			],
		},
		component: () => import('@/views/features-media.vue'),
	},
	{
		path: '/features/multi-account/',
		name: 'features-multi-account',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Multi-Account Features – Run Multiple Accounts`,
			keywords: 'gb whatsapp multi-account, multiple accounts, dual account, account switching',
			description: `Set up and manage multiple WhatsApp accounts on one device with GB WhatsApp multi-account features.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/features/multi-account/`,
				},
			],
		},
		component: () => import('@/views/features-multi-account.vue'),
	},
	{
		path: '/use-cases/',
		name: 'use-cases',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Use Cases – How Users Benefit from Advanced Features`,
			keywords: 'gb whatsapp use cases, gb whatsapp business, gb whatsapp social media',
			description: `Explore various use cases for GB WhatsApp: business applications, social media integration, gaming communities, and international communication.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/use-cases/`,
				},
			],
		},
		component: () => import('@/views/use-cases.vue'),
	},
	{
		path: '/use-cases/business/',
		name: 'use-cases-business',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for Business – Marketing Tools, Auto-Reply & Customer Management`,
			keywords: 'gb whatsapp business, marketing tools, auto-reply, customer management, bulk messaging',
			description: `Learn how businesses use GB WhatsApp: marketing campaigns, auto-reply features, customer management, and file sharing capabilities.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/use-cases/business/`,
				},
			],
		},
		component: () => import('@/views/use-cases-business.vue'),
	},
	{
		path: '/use-cases/social-media/',
		name: 'use-cases-social-media',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for Social Media – Community Building & Influencer Tools`,
			keywords: 'gb whatsapp social media, community building, influencer tools, social media management',
			description: `Discover how to use GB WhatsApp for social media: managing communities, influencer tools, and social media integration.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/use-cases/social-media/`,
				},
			],
		},
		component: () => import('@/views/use-cases-social-media.vue'),
	},
	{
		path: '/use-cases/gaming/',
		name: 'use-cases-gaming',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for Gaming Communities – Guild Management & Event Notifications`,
			keywords: 'gb whatsapp gaming, game community, guild management, tournament notifications',
			description: `Use GB WhatsApp for gaming: managing guilds, sharing game media, event notifications, and privacy settings for gamers.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/use-cases/gaming/`,
				},
			],
		},
		component: () => import('@/views/use-cases-gaming.vue'),
	},
	{
		path: '/use-cases/international/',
		name: 'use-cases-international',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for International Communication – Multi-Language & Cross-Border`,
			keywords: 'gb whatsapp international, multi-language, cross-border communication, global usage',
			description: `Explore GB WhatsApp for international use: multi-language support, account multi-opening, and media transmission across borders.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/use-cases/international/`,
				},
			],
		},
		component: () => import('@/views/use-cases-international.vue'),
	},
	{
		path: '/tutorials/',
		name: 'tutorials',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Tutorials – Step-by-Step Guides & How-Tos`,
			keywords: 'gb whatsapp tutorials, how to use gb whatsapp, step by step guide',
			description: `Comprehensive tutorials for GB WhatsApp: installation guides, backup and restore, customization, and troubleshooting tips.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/tutorials/`,
				},
			],
		},
		component: () => import('@/views/tutorials.vue'),
	},
	{
		path: '/tutorials/installation/',
		name: 'tutorials-installation',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Installation Guide – Download & Setup Tutorial`,
			keywords: 'gb whatsapp installation, download gb whatsapp, install tutorial, setup guide',
			description: `Complete installation guide for GB WhatsApp: download instructions, installation steps, permission settings, and first login setup.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/tutorials/installation/`,
				},
			],
		},
		component: () => import('@/views/tutorials-installation.vue'),
	},
	{
		path: '/tutorials/backup-restore/',
		name: 'tutorials-backup-restore',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Backup & Restore Guide – Data Protection Tutorial`,
			keywords: 'gb whatsapp backup, restore chat, data protection, cloud backup',
			description: `Learn how to backup and restore GB WhatsApp data: cloud storage options, data migration, encryption, and restore procedures.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/tutorials/backup-restore/`,
				},
			],
		},
		component: () => import('@/views/tutorials-backup-restore.vue'),
	},
	{
		path: '/tutorials/customization/',
		name: 'tutorials-customization',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Customization Guide – Themes, Fonts & Layouts`,
			keywords: 'gb whatsapp customization, themes, font styles, chat bubbles, notification settings',
			description: `Master GB WhatsApp customization: changing themes, customizing fonts, chat bubbles, notification sounds, and layouts.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/tutorials/customization/`,
				},
			],
		},
		component: () => import('@/views/tutorials-customization.vue'),
	},
	{
		path: '/gb-whatsapp-pc/',
		name: 'gb-whatsapp-pc',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for PC – Download, Install & Features`,
			keywords: 'gb whatsapp pc, gb whatsapp desktop, whatsapp mods for pc, gb whatsapp windows, gb whatsapp mac',
			description: `Learn how to download and use GB WhatsApp on PC. Installation guide, features, limitations, and security tips included.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/gb-whatsapp-pc/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-pc.vue'),
	},
	{
		path: '/gb-whatsapp-ios/',
		name: 'gb-whatsapp-ios',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp for iOS – Compatibility, Installation & Features`,
			keywords: 'gb whatsapp ios, gb whatsapp iphone, whatsapp mods for ios, gb whatsapp ipad, gb whatsapp jailbreak',
			description: `Discover how to install and use GB WhatsApp on iOS devices. Features, compatibility, and safety tips included.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/gb-whatsapp-ios/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-ios.vue'),
	},
	{
		path: '/gb-whatsapp-web/',
		name: 'gb-whatsapp-web',
		meta: {
			appname: 'GBWhatsApp',
			title: `GB WhatsApp Web – Features, Access & Tips`,
			keywords: 'gb whatsapp web, whatsapp web mods, gb whatsapp online, gb whatsapp browser, whatsapp web pc',
			description: `Learn how to access and use GB WhatsApp Web. Features, limitations, and tips for smooth usage included.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/gb-whatsapp-web/`,
				},
			],
		},
		component: () => import('@/views/gb-whatsapp-web.vue'),
	},
	{
		path: '/blog/',
		name: 'blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: `Blog Collection — GBWA Tips and Tutorials`,
			keywords: 'gb whatsapp blogs',
			description: `Welcome to our blog page about GB WhatsApp. Find instructions and hot topics here.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/blog/`,
				},
			],
		},
		component: () => import('@/views/blogs.vue'),
	},
	{
		path: '/download',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: ` Download Page | GB WhatsApp Latest APK 2026`,
			keywords: 'gb whatsapp apk download',
			description: `Direct to the safe page of GB WhatsApp APK. Download the app and follow the guide to install it on Android phones.`,
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-dwnplus.org/download/'
				}
			]
		},
		component: () => import('@/views/download.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'en-privacy-policy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy – GB-DWNPlus',
			keywords: 'privacy，GBWhatsApp',
			description: 'Read the GB-DWNPlus.org Privacy Policy. We respect your privacy and only share GBWhatsApp information, not personal data or developer content.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-dwnplus.org/privacy-policy'
				}
			]
		},
		component: () => import('@/views/privacy.vue'),
	},
	{
		path: '/disclaimer',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer – gb-dwnplus.org Official Information Notice',
			keywords: 'GB-DWNPlus.org，GB WhatsApp APK',
			description: 'GB-DWNPlus.org respects your privacy and only shares trusted GBWhatsApp information. We do not collect personal data or represent the developers.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-dwnplus.org/disclaimer/'
				}
			]
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{
		path: '/contact-us',
		name: 'en-contact-us',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Contact GB DwnPlus | Get Help or Share Feedback',
			keywords: 'GB DwnPlus contact',
			description: 'Contact GB DwnPlus for any questions, suggestions, or feedback. Our team is always ready to help and values your input.',
			link: [
				{
					rel: 'canonical',
					href: 'https://gb-dwnplus.org/contact-us'
				}
			]
		},
		component: () => import('@/views/contact-us.vue'),
	},
	{
		path: '/download-gbwhatsapp-latest-version/',
		name: 'download-gbwhatsapp-latest-version',
		meta: {
			appname: 'GBWhatsApp',
			title: `How to Download GBWhatsApp Latest Version`,
			keywords: 'download GBWhatsApp latest version',
			description: `GBWhatsApp latest version offers privacy, themes, and advanced messaging. Users can safely download, explore features, updates, and manage settings effectively.`,
			link: [
				{
					rel: 'canonical',
					href: `https://gb-dwnplus.org/download-gbwhatsapp-latest-version/`,
				},
			],
		},
		component: () => import('@/views/blog-1.vue'),
	},

]


let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
